export const SHOW_THE_WAY_BULLET_TABS = 'show-the-way-bullet-tabs';
export const PRE_UPLOAD_SPINNER_TEST_ID = 'pre-upload-spinner';
export const CHOOSE_THE_WAY_PAGE_SPINNER = 'choose-the-way-page-spinner';
export const OUTDATED_FILES_MODAL_TEST_ID = 'outdated-files-modal-test-id';

export const FIRST_STEP_TEST_ID = 'first-step-show-the-way';
export const UPLOAD_OPTION_RADIO_GROUP_TEST_ID = 'upload-option-radio-group';
export const STANDARD_FLOW_RADIO_OPTION_TEST_ID = 'standard-flow-radio-option';
export const CUSTOM_FILE_RADIO_OPTION_TEST_ID = 'custom-file-radio-option';

export const SECOND_STEP_TEST_ID = 'second-step-show-the-way';
export const FILE_UPLOAD_SECTION_TEST_ID = 'file-upload-section';
export const FILE_UPLOAD_COMPONENT_TEST_ID = 'file-upload-component';

export const BULLETS_NAV_NEXT_BTN_TEST_ID = 'bullets-nav-next-btn';
export const BULLETS_NAV_BACK_BTN_TEST_ID = 'bullets-nav-back-btn';
export const BULLETS_COMPLETE_NEXT_BTN_TEST_ID = 'bullets-complete-next-btn';
export const BULLET_TABS_SPINNER_TEST_ID = 'bullet-tabs-spinner';
